module.exports = __webpack_public_path__ + "static/media/image3.6e5d33c3.JPG";